import React, {useRef, useState} from 'react';
import {fetchSendersList, readFile, runScript} from "../../services";
import Fetch from "../../Elements/Fetch";
import FormGroupRowSender from "../../Elements/FormGroupRowSender";
import useSubmittingButton from "../../hooks/useSubmittingButton";
import {Col, Row} from "reactstrap";

const MigrateDocumentsImport = () => {

    const [senderId, setSenderId] = useState(null);
    const [validFile, setValidFile] = useState(false);
    const inputRef = useRef();

    const {errorMessage, loader, SubmittingButton} = useSubmittingButton();

    const handleSubmit = async () => {
        const fileContents = await readFile(inputRef.current.files[0]);
        const response = await runScript('MigrateDocumentsImport', {
            senderId: senderId,
            fileContents: fileContents
        });

        if (response.status === 200) {
            setSenderId(null);
            setValidFile(false);
            inputRef.current.value = '';
            return "File successfully queued for processing.";
        } else {
            throw new Error(`${response.status}: ${response.statusText}. Contact a site administrator. This error probably won't go away by itself.`);
        }
    };

    const disabled = !validFile || senderId == null;

    return (
        <>
            <h4>Migrate Documents Import</h4>

            {errorMessage}

            <form style={{maxWidth: 600}}>
                <Fetch fetchFunction={fetchSendersList} className="form-group">
                    {senderList => (
                        <FormGroupRowSender
                            label="Sender"
                            value={senderId}
                            onChange={setSenderId}
                            senders={senderList}
                        />
                    )}
                </Fetch>

                <div className="form-group row">
                    <label className="col-3 col-form-label">File</label>
                    <div className="col">
                        <input type="file" required ref={inputRef} onChange={e => setValidFile(!!e.target.value)} accept=".csv"/>
                    </div>
                </div>

                <Row form className="align-items-center">
                    <Col xs="auto">
                        <SubmittingButton onClick={handleSubmit} disabled={disabled}>Submit</SubmittingButton>
                    </Col>
                    <Col xs="auto">
                        {loader}
                    </Col>
                </Row>
            </form>
        </>
    );
};

export default MigrateDocumentsImport;
